import React, {
  ReactNode,
} from 'react';
import Dialog from 'pages/Dashboard/components/Dialog';
import {
  MicIcon,
  PopulateMark,
} from 'core/icons';
import NotesIcon from 'core/icons/notes';
import AddendumIcon from 'core/icons/addendumIcon';

type Feature = {
  icon: ReactNode;
  label: string;
};

const features: Feature[] = [
  {
    icon: <MicIcon className="!w-4 !h-4 text-gray-500 shrink-0" />,
    label: 'One-tap ambient dictation',
  },
  {
    icon: <NotesIcon className="!w-4 !h-4 text-gray-500 shrink-0" />,
    label: 'AI-drafted SOAP note in minutes',
  },
  {
    icon: <AddendumIcon className="!w-4 !h-4 text-gray-500 shrink-0" />,
    label: 'Finalize and sign from your phone',
  },
];

type Props = {
  onClose: () => void;
};

export default function SnapMobileAppDialog({
  onClose,
}: Props) {
  return (
    <Dialog
      open
      onClose={onClose}
      className="!w-[25rem]"
      title={(
        <div className="flex items-center gap-3">
          <PopulateMark className="!w-11 !h-11 shrink-0" />
          <div>
            <p className="text-xs text-gray-400 tracking-wide">Now on iPhone</p>
            <h2 className="text-xl font-medium">Populate SNAP</h2>
          </div>
        </div>
      )}
    >
      <p className="text-sm leading-relaxed text-gray-500">
        Record your visit and SNAP drafts the full SOAP note &mdash; review, edit,
        and sign before the patient leaves the room.
      </p>
      <ul className="flex flex-col gap-2.5 p-0 list-none">
        {features.map(({ icon, label }) => (
          <li key={label} className="flex items-center gap-2.5 text-sm">
            {icon}
            {label}
          </li>
        ))}
      </ul>
      <div className="flex items-center gap-4 p-4 rounded-xl bg-gray-50">
        <img
          className="w-20 h-20 p-1.5 rounded-lg bg-white shrink-0"
          src="/assets/snap-ios-qr.svg"
          alt="QR code to download Populate SNAP from the App Store"
        />
        <div>
          <p className="text-sm font-medium mb-0.5">Scan to download</p>
          <p className="text-xs text-gray-400 leading-snug">
            Open your iPhone camera and point it at the code.
          </p>
        </div>
      </div>
    </Dialog>
  );
}
